import React, { useState } from 'react';
import authService from '../../services/authService';

const LineLoginButton = ({ 
  merchantSlug = null, 
  className = '', 
  size = 'medium',
  disabled = false,
  onError = null 
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLineLogin = () => {
    try {
      // Validate LINE configuration
      if (!authService.validateLineConfig()) {
        const error = 'LINE login is not properly configured';
        console.error(error);
        if (onError) {
          onError(new Error(error));
        }
        return;
      }

      setIsLoading(true);

      // Generate LINE authorization URL
      const lineAuthUrl = authService.generateLineAuthUrl(merchantSlug);
      
      // Redirect to LINE authorization page
      window.location.href = lineAuthUrl;
    } catch (error) {
      console.error('LINE login error:', error);
      setIsLoading(false);
      if (onError) {
        onError(error);
      }
    }
  };

  // Size configurations
  const sizeClasses = {
    small: {
      button: 'px-3 py-2 text-sm',
      icon: 'w-4 h-4',
      text: 'text-sm'
    },
    medium: {
      button: 'px-4 py-3 text-base',
      icon: 'w-5 h-5',
      text: 'text-base'
    },
    large: {
      button: 'px-6 py-4 text-lg',
      icon: 'w-6 h-6',
      text: 'text-lg'
    }
  };

  const currentSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <button
      onClick={handleLineLogin}
      disabled={disabled || isLoading}
      className={`
        inline-flex items-center justify-center gap-3 
        bg-green-500 hover:bg-green-600 
        disabled:bg-gray-400 disabled:cursor-not-allowed
        text-white font-medium rounded-lg
        transition-colors duration-200
        focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2
        ${currentSize.button}
        ${className}
      `}
      aria-label="使用 LINE 登入"
    >
      {isLoading ? (
        <>
          <div className={`animate-spin rounded-full border-2 border-white border-t-transparent ${currentSize.icon}`} />
          <span className={currentSize.text}>登入中...</span>
        </>
      ) : (
        <>
          <LineIcon className={currentSize.icon} />
          <span className={currentSize.text}>使用 LINE 登入</span>
        </>
      )}
    </button>
  );
};

// LINE icon component
const LineIcon = ({ className = '' }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/>
  </svg>
);

export default LineLoginButton;